import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { scoreboardActions } from '../../../../store/scoreboard/scoreboardSlice';
import { fetchStaticJson } from '../../../../utils/utils';
import ItemBlock from '../../ContestInfo/itemBlock/ItemBlock';
import StatCard from './statCard/StatCard';
import studentCardImg from '../../../../assets/scoreboard/studentCardImg.png';
import schoolCardImg from '../../../../assets/scoreboard/schoolCardImg.png';
import classes from './BannerButtom.module.css';

const BannerButtom = () => {

    const dispatch = useDispatch();
    const { texts } = useSelector(state => state.translate);
    const { counters, contestId } = useSelector(state => state.scoreboard);
    const { currentContestId } = useSelector(state => state.contest);

    useEffect(() => {
        if (counters.students !== null && String(currentContestId) === String(contestId))
            return;
        const fetchData = async () => {
            try {
                const countersUrl = `${window.config.bucketFilesUrl}/scoreboards/2026/${currentContestId}-counters.json`;
                const data = await fetchStaticJson(countersUrl);
                dispatch(scoreboardActions.setCountersData({ counters: data.counters, contestId: data?.contestId ?? null, }),
                );
            }
            catch (error) {
                console.error('Error fetching school scoreboard:', error);
            }
        };
        fetchData();
    }, []);
    return (
        <ItemBlock className={classes.wrapper}>
            <div className={classes.content}>
                <StatCard
                    number={counters.schools}
                    text={texts.topicSchools}
                    image={schoolCardImg}
                />
                <StatCard
                    number={counters.students}
                    text={texts.topicStudents}
                    image={studentCardImg}
                />
            </div>
        </ItemBlock>
    );
};

export default BannerButtom;

